var $e12613d3ea035e13$exports = {};
$e12613d3ea035e13$exports = {
    "actions": `Dzia\u{142}ania`,
    "hideButtonLabel": `Wy\u{15B}wietl mniej`,
    "noTags": `Brak`,
    "showAllButtonLabel": (args, formatter)=>`Poka\u{17C} wszystko (${formatter.number(args.tagCount)})`
};


export {$e12613d3ea035e13$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
